import React from "react";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { TextField } from "@syos-music/form";

import { Grid, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import OptionsField from "./OptionsField";

export default function FormDialog({
  onSubmit,
  isOrderPaid,
  cartItem,
  children,
}) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      {children({ open, close })}

      <Dialog open={isOpen} onClose={close} maxWidth="md">
        <Form
          onSubmit={(...args) =>
            Promise.resolve(onSubmit?.(...args)).then((err) => {
              if (err) return err;
              close();
            })
          }
          initialValues={{
            id: cartItem.id,
            quantity: cartItem.quantity,
            options: cartItem.options || {},
          }}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting, pristine }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">Modifier les options</Dialog.Title>

              <Dialog.Content>
                <Grid container justifyContent="flex-end">
                  {!isOrderPaid && (
                    <Grid item xs={12}>
                      <TextField
                        name="quantity"
                        type="number"
                        required
                        label="Quantité"
                        InputProps={{
                          inputProps: { min: 1, step: 1 },
                        }}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <OptionsField
                      name="options"
                      isOrderPaid={isOrderPaid}
                      cartItem={cartItem}
                    />
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton
                  type="submit"
                  loading={submitting}
                  disabled={pristine}
                >
                  Valider
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
